import { render, staticRenderFns } from "./conversation-master-builder.vue?vue&type=template&id=bd2dfb8a&scoped=true"
import script from "./conversation-master-builder?vue&type=script&lang=ts&external"
export * from "./conversation-master-builder?vue&type=script&lang=ts&external"
import style0 from "./conversation-master-builder.less?vue&type=style&index=0&id=bd2dfb8a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2dfb8a",
  null
  
)

export default component.exports